import React from 'react';
import { Select } from 'antd';
import { getIn, useFormikContext } from 'formik';

import { PrimaryContactForEnum } from 'api/backofficeApiClient';
import {
  CONTACT_FOR_ALL_UI_VALUE,
  getContactForOptions,
  handleContactForSelectChange,
} from 'utils/primaryContactUtils';

type Props = {
  fieldName: string;
  disabled?: boolean;
};

export default function ContactForSelect(props: Props) {
  const { fieldName, disabled = false } = props;
  const formik = useFormikContext<Record<string, unknown>>();
  const storedValue = getIn(formik.values, fieldName) as
    | PrimaryContactForEnum[]
    | undefined;

  return (
    <Select
      disabled={disabled}
      mode="multiple"
      allowClear
      placeholder="Select contact purposes"
      className="full-width"
      options={[
        { label: 'All', value: CONTACT_FOR_ALL_UI_VALUE },
        ...getContactForOptions(),
      ]}
      value={storedValue ?? []}
      onChange={(selected: PrimaryContactForEnum[]) => {
        handleContactForSelectChange(selected, (value) => {
          formik.setFieldValue(fieldName, value, false);
        });
      }}
      onBlur={() => formik.setFieldTouched(fieldName, true, false)}
    />
  );
}
